type ASTNode = {
  type: string;
  children?: ASTNode[];
  text?: string;
};
export function extractPlainTextFromAST(ast: ASTNode | ASTNode[] | string): string {
  if (typeof ast === 'string') {
    return ast;
  }
  if (Array.isArray(ast)) {
    return ast.map(extractPlainTextFromAST).join('');
  }
  if (ast && typeof ast === 'object') {
    if (ast.text) {
      return ast.text;
    }
    return (ast.children || []).map(extractPlainTextFromAST).join('');
  }
  return '';
}